export class QualitysCreateRequest {
    qualityId:number;
    qualityName:string;


}